import { NgModule } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@NgModule({
  declarations: [SpinnerComponent],
  exports: [
    SpinnerComponent
  ]
})
export class SpinnerModule { }
